module.exports = __webpack_public_path__ + "img/img/ray.4e212768.png";